import React, { useContext, useEffect, useState, ReactNode } from "react";
import { node } from "prop-types";
import { Container, Grid } from "@mui/material";
import { Box } from "@mui/system";
import { Carousel } from "@/components";
import { PartnerImagePath } from "@/hooks";
import { getPartnerKey } from "@/utils";
import { CarouselItems } from "../assets";
import { AuthPageCarousel } from "./AuthPageCarousel";
import { enqueueSnackbar } from "notistack";
import { useTextDomainContext } from "@/app/providers";

type AuthPageLayoutProps = {
  children: ReactNode;
};

export const AuthPageLayout = (props: AuthPageLayoutProps) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const partnerKey = getPartnerKey();
  const items = CarouselItems();
  const [loginImage1, setLoginImage1] = useState(null);

  useEffect(() => {
    let isMounted = true;

    PartnerImagePath(partnerKey, "login/login-1.png")
      .then((imageUrl) => {
        if (isMounted) {
          setLoginImage1(imageUrl);
        }
      })
      .catch((err) => {
        enqueueSnackbar(gettext("Error loading image:" + err.message), {
          variant: "error",
        });
      });

    return () => {
      isMounted = false;
    };
  }, [gettext, partnerKey]);

  return (
    <>
      <Grid size={{ md: 6 }} sx={{ minHeight: `calc(100vh - 64px )` }}>
        <Box
          sx={{
            height: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Container
            sx={{
              textAlign: "center",
            }}
          >
            {props.children}
          </Container>
        </Box>
      </Grid>

      <Grid
        size={{
          md: 6,
        }}
        sx={{
          backgroundImage: loginImage1 ? `url(${loginImage1})` : undefined,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: `calc(100vh - 64px)`,
          position: "relative",
          display: {
            xs: "none",
            md: "block",
          },
        }}
      >
        <Grid
          size={{ md: 12 }}
          sx={{
            backgroundColor: "secondary.700",
            opacity: 0.5,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
          }}
        />
        <Carousel
          indicatorContainerProps={{
            style: { marginLeft: "50px", textAlign: "left" },
          }}
          sx={{ opacity: 1 }}
        >
          {items.map((item, i) => (
            <AuthPageCarousel key={i} item={item} />
          ))}
        </Carousel>
      </Grid>
    </>
  );
};

AuthPageLayout.propTypes = {
  children: node.isRequired,
};
